import { emulatorScreen, mobileScreen } from "../../../utils/styleUtils";

const styles = (theme) => ({

  graphContainer: {
    width: 565,
    [emulatorScreen(theme)]: {
      width: 330
    },
    [mobileScreen(theme)]: {
      width: 350
    },
  },

  verticalLinesContainer: {
    position: "absolute",
    top: "-52px",
    left: "225px",
    [emulatorScreen(theme)]: {
      top: "-35px",
      left: "150px",
    },
    [mobileScreen(theme)]: {
      top: "-25px",
      left: "100px",
    },
  },

  graphLines: {
    borderLeft: "5px solid #565656",
    borderBottom: "5px solid #565656",
    height: "330px",
    width: "460px",
    position: "relative",
    [emulatorScreen(theme)]: {
      width: "290px",
      height: "210px",
      borderWidth: "3px",
    },
    [mobileScreen(theme)]: {
      width: "200px",
      height: "150px",
      borderWidth: "3px",
    },
  },

  graphYLable: {
    height: "18px",
    position: "absolute",
    top: "7px",
    left: "-90px",
    [emulatorScreen(theme)]: {
      height: "12px",
      left: "-60px",
    },
    [mobileScreen(theme)]: {
      height: "10px",
      left: "-50px",
    },
  },

  graphXLable: {
    height: "18px",
    position: "absolute",
    bottom: "-35px",
    right: "5px",
    [emulatorScreen(theme)]: {
      height: "12px",
      bottom: "-25px",
    },
    [mobileScreen(theme)]: {
      height: "10px",
      bottom: "-22px",
    },
  },

  dragLineMessage: {
    height: "130px",
    position: "absolute",
    right: "-20px",
    top: "80px",
    [emulatorScreen(theme)]: {
      height: "90px",
      right: "-25px",
      top: "50px",
    },
    [mobileScreen(theme)]: {
      top: "25px",
      right: "-25px",
      height: "75px",
    },
  },

  questionMark: {
    width: "150px",
    [emulatorScreen(theme)]: {
      width: "95px",
    },
    [mobileScreen(theme)]: {
      width: "85px",
    },
  },

  arrows: {
    position: "absolute",
    height: "30px",
    top: "185px",
    left: "-50px",
    [emulatorScreen(theme)]: {
      top: "117px",
      left: "12px",
      height: "18px",
    },
    [mobileScreen(theme)]: {
      top: "84px",
      left: "8px",
      height: "10px",
    },
  },

  defaultLine: {
    transform: "rotate(-45deg)",
    position: "absolute",
    height: "400px",
    width: "8px",
    backgroundColor: "#003e4c",
    borderRadius: "5px",
    [emulatorScreen(theme)]: {
      height: "260px",
      width: "6px",
    },
    [mobileScreen(theme)]: {
      height: "190px",
      width: "6px",
    },
  },

  correctLine: {
    transform: "rotate(-45deg)",
    position: "absolute",
    height: "400px",
    width: "8px",
    borderRadius: "5px",
    [emulatorScreen(theme)]: {
      height: "260px",
      width: "6px",
    },
    [mobileScreen(theme)]: {
      height: "190px",
      width: "6px",
    },
  },

  dragableLine: {
    display: "flex",
    justifyContent: "center",
    height: "400px",
    width: "6px",
    position: "relative",
    borderRadius: "5px",
    transform: "rotate(-45deg)",
    [emulatorScreen(theme)]: {
      height: "260px",
      width: "6px",
    },
    [mobileScreen(theme)]: {
      height: "190px",
      width: "6px",
    },
  },

  dragableLineContainer: {
    display: "flex",
    justifyContent: "center",
    width: "6px",
    position: "relative",
    borderRadius: "5px",
    transform: "rotate(-45deg)",
    top: "28px",
    left: "-68px",
    height: "0",
    position: "absolute",
    // [emulatorScreen(theme)]: {
    //   height: "260px",
    //   width: "5px",
    // },
    // [mobileScreen(theme)]: {
    //   height: "190px",
    //   width: "4px"
    // },
  },

  fadedDot: {
    position: "absolute",
    transform: "rotate(45deg)",
    border: "5px solid #003E4C",
    borderRadius: "50%",
    padding: "10px",
    backgroundColor: "#003E4C",
    top: "120px",
    color: "blue",
    [emulatorScreen(theme)]: {
      padding: "7px",
      borderWidth: "4px",
    },
    [mobileScreen(theme)]: {
      padding: "7px",
      borderWidth: "4px",
    },
  },

  correctDot: {
    position: "absolute",
    transform: "rotate(45deg)",
    border: "5px solid #003e4c",
    borderRadius: "50%",
    padding: "10px",
    backgroundColor: "#CACDCE",
    color: "blue",
    zindex: 100,
    // border: "5px solid",
    [emulatorScreen(theme)]: {
      padding: "7px",
      border: "4px solid #003e4c",
    },
    [mobileScreen(theme)]: {
      padding: "7px",
      border: "4px solid #003e4c",
    },
  },

  draggableDot: {
    transform: "rotate(45deg)",
    borderRadius: "50%",
    padding: "10px",
    color: "blue",
    border: "5px solid",
    [emulatorScreen(theme)]: {
      padding: "7px",
      border: "4px solid",
    },
    [mobileScreen(theme)]: {
      padding: "7px",
      border: "4px solid",
    },
  },

  internationalContainerMajor: {
    // justifyContent: "center",
    justifyContent: "center",
    position: "relative",
    display: "flex",
    cursor: "pointer",
    [emulatorScreen(theme)]: {
      justifyContent: "start",
    },
  },

  internationalContainerChild: {
    position: "relative",
    display: "flex",
    height: 400,
    width: 400,

    [emulatorScreen(theme)]: {
      height: 270,
      width: 270,
    },
    [mobileScreen(theme)]: {
      height: 270,
      width: 320,
    },
  },
  pLabels: {
    left: -40,  
    top: -20,
    position: 'absolute',
    color: "#003e4c",
    fontSize: 26,
    width: 20,
    height: 25,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 18,
      left: -30,  
      top: -20,
    },
  },

  qLabels: {
    right: -60,
    bottom: -60,
    zIndex: 11,
    position: 'absolute',
    color: "#003e4c",
    fontSize: 26,
    width: 20,
    height: 25,
    [emulatorScreen(theme)]: {
    },
    [mobileScreen(theme)]: {
      fontSize: 18,
      right: 30,
      bottom: -15,
    },
  },

  yLabels: {
    // margin: 10,
    color: "#003e4c",
    fontSize: 22,
    width: 20,
    height: 25,
    [mobileScreen(theme)]: {
      fontSize: 16,
    },
  },

  line1: {
    position: "absolute",
    top: 179,
    width: "55%",
    left: 0,
    [emulatorScreen(theme)]: {
      position: "absolute",
      top: 120,
      width: "55%",
      left: 50,
    },
    [mobileScreen(theme)]: {
      position: "absolute",
      top: 120,
      width: "55%",
      left: 50,
    },
  },

// start new design for white dotted

  linenewHorzi4 : {
    height: "54%",
    top: 85,
    transform: "rotate(-90deg)",
    left: "31%",
    position: "absolute",
    [emulatorScreen(theme)]: {
      height: "40%",
      top: 85,
      left: 135,
    },
    [mobileScreen(theme)]: {
      height: "54%",
      top: 59,
      left: 83,
    },
  },

  linenewVert4: {
    height: "54%",
    top: 198,
    left: "50.8%",
    position: "absolute",
    [emulatorScreen(theme)]: {
      // height: "40%",
      // top: 85,
      // left: 135,
    },
    [mobileScreen(theme)]: {
      height: "55%",
      top: 133,
      left: 136,
    },
  },

// end new design for white dotted

// start  new design for blue dotted
  BlueHoriLine2: {
    height: "55%",
    top: 80,
    left: 88,
    position: "absolute",
    transform: "rotate(90deg)",
    [emulatorScreen(theme)]: {
      // height: "15%",
      // top: 87,
      // left: 136,
    },
    [mobileScreen(theme)]: {
      height: "55%",
      top: 55.75,
      left: 59,
    },
  },

  BlueVertiLine2: {
    height: "55%",
    top: 195,
    left: 203.2,
    position: "absolute",
    [emulatorScreen(theme)]: {
      // height: "15%",
      // top: 87,
      // left: 136,
    },
    [mobileScreen(theme)]: {
      height: "55%",
      top: 133,
      left: 136.2,
    },
  },
// end new design for blue dotted

  line15: {
    height: "16%",
    top: 128,
    left: 202,
    position: "absolute",
    [emulatorScreen(theme)]: {
      height: "15%",
      top: 87,
      left: 136,
    },
    [mobileScreen(theme)]: {
      height: "15%",
      top: 87,
      left: "50.49%",
    },
  },

  line22: {
    height: "42%",
    top: 121,
    left: 378,
    position: "absolute",
    [emulatorScreen(theme)]: {
      height: "39%",
      top: 85,
      width: 17,
      left: 251.2,
    },
    [mobileScreen(theme)]: {
      height: "40%",
      top: 84,
      left: "93.6%",
    },
  },

  line2: {
    position: "absolute",
    top: 189,
    width: "25.5%",
    left: 111,
    [emulatorScreen(theme)]: {
      top: 125,
      left: 75,
      width: "26%",
      height: "2%",
    },
    [mobileScreen(theme)]: {
      top: "46.71%",
      left: 75,
      height: "1.5%",
    },
  },

  line18: {
    height: "16%",
    top: 191,
    left: "50.45%",
    position: "absolute",
    [emulatorScreen(theme)]: {
      height: "17%",
      top: 129,
      left: 135,
    },
    [mobileScreen(theme)]: {
      height: "17%",
      top: 129,
      left: "50.1%",
    },
  },

  line5: {
    position: "absolute",
    top: 189,
    width: "19.7%",
    left: 216,
    [emulatorScreen(theme)]: {
      top: 126.5,
      left: 145,
    },
    [mobileScreen(theme)]: {
      width: "21.7%",
      top: 126,
      left: 143,
    },
  },

  line28: {
    height: "19%",
    top: 195,
    position: "absolute",
    marginLeft: "50%",
    paddingTop: "15%",
    [emulatorScreen(theme)]: {
      top: 133,
    },
    [mobileScreen(theme)]: {
      top: 133,
      marginLeft: "49.9%",
    },
  },

  line9: {
    height: "41%",
    top: 195,
    right: 89,
    position: "absolute",
    [emulatorScreen(theme)]: {
      top: 131,
      right: 60,
    },
    [mobileScreen(theme)]: {
      top: 131,
      right: 60,
    },
  },

  line26: {
    height: "18.5%",
    top: 257,
    position: "absolute",
    left: 377,
    [emulatorScreen(theme)]: {
      top: 173,
      left: 250.45,
    },
    [mobileScreen(theme)]: {
      top: 173,
      left: 251.45,
    },
  },

  line8: {
    height: "41%",
    top: 195,
    right: 89,
    position: "absolute",
    [emulatorScreen(theme)]: {
      top: 131,
      right: 60,
    },
    [mobileScreen(theme)]: {
      top: 131,
      right: 60,
    },
  },

  line3: {
    position: "absolute",
    top: 189,
    width: "25.5%",
    left: 112,
    [emulatorScreen(theme)]: {
      top: 127,
      left: 75,
    },
    [mobileScreen(theme)]: {
      top: 126,
      left: 75,
    },
  },

  line6: {
    position: "absolute",
    top: 189,
    width: "25.5%",
    left: 215,
    [emulatorScreen(theme)]: {
      top: 127,
      left: 144,
    },
    [mobileScreen(theme)]: {
      top: 126,
      left: 144,
    },
  },

  line19: {
    height: "16%",
    top: 193,
    left: 212,
    position: "absolute",
    [emulatorScreen(theme)]: {
      top: 128,
      left: 142.5,
    },
    [mobileScreen(theme)]: {
      top: 128,
      left: 141.9,
      width: "2%",
    },
  },

  // start design green dotted lines
  greenHoriLine1: {
    height: "22%",
    top: 56,
    left: 72,
    position: "absolute",
    transform: "rotate(90deg)",
    [emulatorScreen(theme)]: {
      height: "18%",
      top: 86,
      left: 141.5,
    },
    [mobileScreen(theme)]: {
      height: "18%",
      top: 86,
      left: 142.5,
    },
  },
  greenHoriLine2: {
    height: "55%",
    top: 80,
    left: 88,
    position: "absolute",
    transform: "rotate(90deg)",
    [emulatorScreen(theme)]: {
      // height: "15%",
      // top: 87,
      // left: 136,
    },
    [mobileScreen(theme)]: {
      height: "55%",
      top: 56,
      left: 59,
    },
  },
  greenHoriLine3: {
    height: "21.5%",
    top: 244,
    left: 71,
    position: "absolute",
    transform: "rotate(90deg)",
    [emulatorScreen(theme)]: {
      height: "18%",
      top: 86,
      left: 141.5,
    },
    [mobileScreen(theme)]: {
      height: "18%",
      top: 86,
      left: 142.5,
    },
  },
  greenHoriLine4: {
    height: "22.5%",
    top: 147.5,
    left: 165,
    position: "absolute",
    transform: "rotate(90deg)",
    [emulatorScreen(theme)]: {
      height: "18%",
      top: 86,
      left: 141.5,
    },
    [mobileScreen(theme)]: {
      height: "18%",
      top: 86,
      left: 142.5,
    },
  },

  greenVertiLine1: {
    height: "21.5%",
    top: 104,
    left: 122,
    position: "absolute",
    [emulatorScreen(theme)]: {
      height: "18%",
      top: 86,
      left: 141.5,
    },
    [mobileScreen(theme)]: {
      height: "18%",
      top: 86,
      left: 142.5,
    },
  },
  greenVertiLine2: {
    height: "55%",
    top: 194,
    left: 203,
    position: "absolute",
    [emulatorScreen(theme)]: {
      // height: "18%",
      // top: 86,
      // left: 141.5,
    },
    [mobileScreen(theme)]: {
      height: "55%",
      top: 133,
      left: 136,
    },
  },
  // start design green dotted lines

  line10: {
    height: "34%",
    top: 195,
    left: "74.45%",
    position: "absolute",
    [emulatorScreen(theme)]: {
      top: 131,
      left: 201.5,
    },
    [mobileScreen(theme)]: {
      top: 131,
      left: 197,
      width: "4%",
    },
  },

  line25: {
    height: "19%",
    top: 195,
    position: "absolute",
    left: "52.9%",
    paddingTop: "15%",
    [emulatorScreen(theme)]: {
      top: 132,
      left: 142,
    },
    [mobileScreen(theme)]: {
      top: 132,
      left: 142,
    },
  },

  line27: {
    height: "18.5%",
    top: 257,
    position: "absolute",
    left: 389,
    [emulatorScreen(theme)]: {
      top: 173,
      left: 258,
    },
    [mobileScreen(theme)]: {
      top: 173,
      left: 256,
      width: "3%",
    },
  },

  line23: {
    height: "34%",
    top: 125,
    left: 389,
    position: "absolute",
    [emulatorScreen(theme)]: {
      top: 85,
      left: 251.5,
      height: "32%",
      width: 17,
    },
    [mobileScreen(theme)]: {
      top: 87,
      width: "4%",
      left: 255.5,
    },
  },

  line4: {
    position: "absolute",
    top: 188,
    width: "25.5%",
    left: 111,
    [emulatorScreen(theme)]: {
      top: 126,
      height: "2%",
      left: 75,
    },
    [mobileScreen(theme)]: {
      top: 126,
      left: 75,
    },
  },

  line7: {
    position: "absolute",
    top: 189,
    width: "20%",
    left: 215,
    [emulatorScreen(theme)]: {
      top: 126,
      left: 144,
    },
    [mobileScreen(theme)]: {
      top: 127,
      left: 144,
    },
  },

  line17: {
    height: "17%",
    top: 122,
    left: "52.9%",
    position: "absolute",
    [emulatorScreen(theme)]: {
      height: "18%",
      top: 77,
      left: 141.5,
    },
    [mobileScreen(theme)]: {
      height: "18%",
      top: 77,
      left: 141.5,
    },
  },

  line20: {
    height: "17%",
    top: 189,
    left: "52.9%",
    position: "absolute",
    [emulatorScreen(theme)]: {
      top: 130,
      left: 142,
    },
    [mobileScreen(theme)]: {
      top: 130,
      left: 142,
    },
  },

// new divs
  shape2Major: {
    width: 156,
    overflow: "hidden",
    top: 14,
    left: 42,
    position: "absolute",
    zIndex: 3,
    height: 65,
    clipPath: "polygon(0 0, 0% 100%, 100% 100%)",
    shapeOutside: "polygon(0 0, 0% 100%, 100% 100%)",
    [emulatorScreen(theme)]: {
      // width: 100,
      // top: 31,
      // left: 75,
      // height: 53,
    },
    [mobileScreen(theme)]: {
      width: 90,
      top: 13,
      left: 37,
      height: 34.5,
    },
  },

  shape2Child: {
    height: "100%",
    width: "100%",
    // marginTop: 5,
    [emulatorScreen(theme)]: {
      // height: 48,
      // width: "65%",
    },
    [mobileScreen(theme)]: {
      // marginTop: 4,
      // height: 49,
      // width: "65%",
    },
  },

  shape5Major: {
    width: 165,
    overflow: "hidden",
    top: 85,
    left: 42,
    position: "absolute",
    zIndex: 3,
    height: 273,
    clipPath: "polygon(0 0, 0% 100%, 100% 0)",
    shapeOutside: "polygon(0 0, 0% 100%, 100% 0)",
    [emulatorScreen(theme)]: {
      // width: 54,
      // top: 82.5,
      // left: 144.5,
      // height: 44.5,
    },
    [mobileScreen(theme)]: {
      width: 95,
      top: 50.5,
      left: 37,
      height: 146.5,
    },
  },

  shape5Child: {
    height: "100%",
    // float: "left",
    // height: 60,
    // clipPath: "polygon(0 0, 0% 100%, 100% 100%)",
    // shapeOutside: "polygon(0 0, 0% 100%, 100% 100%)",
    // width: "100%",
    // marginTop: 5,
    [emulatorScreen(theme)]: {
      // height: 40,
    },
    [mobileScreen(theme)]: {
      // height: 40,
    },
  },


  shape3Major: {
    width: 166,
    overflow: "hidden",
    top: 92,
    left: 44,
    position: "absolute",
    zIndex: 3,
    height: 274,
    clipPath: "polygon(100% 0, 0% 100%, 100% 100%)",
    shapeOutside: "polygon(100% 0, 0% 100%, 100% 100%)",
    [emulatorScreen(theme)]: {
      // width: 65,
      // top: 32,
      // left: 266,
      // height: 51.5,
    },
    [mobileScreen(theme)]: {
      width: 96,
      top: 53,
      left: 37.5,
      height: 148,
    },
  },

  shape3Child: {
    height: "100%",
    width: "100%",
    [emulatorScreen(theme)]: {
      // height: 47,
    },
    [mobileScreen(theme)]: {
      // height: 47,
    },
  },

  shape4Major: {
    width: 65,
    overflow: "hidden",
    top: 259,
    left: 187,
    position: "absolute",
    zIndex: 3,
    height: 107,
    clipPath: "polygon(0 0, 0% 100%, 100% 100%)",
    shapeOutside: "polygon(0 0, 0% 100%, 100% 100%)",
    [emulatorScreen(theme)]: {
      // width: 67.5,
      // top: 81.5,
      // left: 75,
      // height: 45.5,
    },
    [mobileScreen(theme)]: {
      width: 40.2,
      top: 172,
      left: 126.5,
      height: 69,
    },
  },

  shape4Child: {
    height: "100%",
    [emulatorScreen(theme)]: {
      // height: 41,
    },
    [mobileScreen(theme)]: {
      // height: 41,
    },
  },
});
export default styles;
